import React, { useRef, useLayoutEffect } from "react";
import ErrorBoundary from "../containers/AuxiliarPages/ErrorBoundary/ErrorBoundary";

export const WebhookInputField = React.memo((props) => {
    const { label, active, webhookUrl, setWebhookUrl } = props;
    const textareaRef = useRef(null);

    useLayoutEffect(() => {
        if (active && textareaRef.current) {
            textareaRef.current.style.height = "auto";
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        }
    }, [active, webhookUrl]);

    return (
        <ErrorBoundary>
            <div className="data-field data-field--webhook">
                <span className="data-field__label">{`${label}: `}</span>
                {webhookUrl ?
                    (active ?
                        <textarea
                            ref={textareaRef}
                            className="webhook-value-input"
                            rows={1}
                            value={webhookUrl}
                            onChange={(e) => setWebhookUrl(e.target.value)}
                        />
                        :
                        <span className="webhook-value">
                            {webhookUrl}
                        </span>
                    )
                    :
                    <span className="color-field--gray">
                        Não há endereço cadastrado
                    </span>
                }
            </div>
        </ErrorBoundary>
    );
});
